// extracted by mini-css-extract-plugin
export var iconWrapper = "e_bz_cG";
export var knowledgeCard = "e_bz_d0";
export var svg = "e_bz_dZ";
export var textWrapper = "e_bz_bb";